module.exports = __webpack_public_path__ + "media/images/admin/icons/radio-597e1dfdc8fb7f6ca87d60a206b48cfb.svg";